import { Grid } from "@mui/material";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { getPermissions } from "../../../commonFunctions/PermissionManger";
import { IRoleMain, IsSmallScreen, MasterPages } from "../../../commonFunctions/CommonFunctions";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { IRows } from "../../../Components/Filter/WSFilterComponent";
import { resetDataComponent } from "../../../StateManagement/actions";
import { Header } from "../../Header/Header";
import WSMobViewDataGrid from "../../../Components/DataGrid/WSMobViewDataGrid";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";

export const BankList: React.FC<any> = React.memo(
    (props) => {
        const navigate = useNavigate();
        const { view, exports, add, edit, del } = getPermissions(MasterPages.Banks, IRoleMain.Masters);
        const source = {
            url: "Bank/search",
            page: 1,
            pageSize: 10,
            filter: [],
            sort: [],
        };
        const [isPopupOpen, setPopupOpen] = useState(false);
        const [selectedId, setSelectedId] = useState<number | null>(null);
        const dispatch = useDispatch();
        const { showMessage } = useSnackbar();
        /**
         * Edit function
         * @param action 
         * @param row 
         */
        const handleAction = (action: string, row: any) => {
            if (action === "Edit") {
                navigate(`/bank/${row?.id}`)
            } else if (action === 'Delete') {
                setSelectedId(row.id); // Set the ID of the row to be deleted
                setPopupOpen(true)
            }
        };

        const columns: IColumns[] = [
            {
                header: "Name",
                fieldName: "name",
                tooltip: true,
                type: 'default'
            },
            {
                header: "Location",
                fieldName: "location",
                tooltip: true,
                type: 'default'
            },

            {
                header: "Phone",
                fieldName: "phoneno",
                tooltip: true,
                type: 'default'
            },
            {
                header: "Actions",
                fieldName: "actions",
                type: "action",
                actions: [edit ? "Edit" : undefined, del ? 'Delete' : undefined],
                actionCallback: (action, row) => handleAction(action, row),
            },
        ];


        const filterRows: IRows[] = [
            {
                label: "Bank Name",
                fieldName: "Name",
                type: "text",
                operator: 'like',
                rowDivision: 12
            }

        ];

        const handleClick = () => {
            navigate('/bank/add')
        }
        const handleDelete = (response: any) => {
            dispatch(resetDataComponent('bank-management-list'));
            showMessage(response?.message, response?.success ? 'success' : 'error')
        };
        return (
            <><Header title="Bank Management" type="simple" isDivider={true} />
                {view ? <Grid container spacing={2}>
                    {!IsSmallScreen() ? <Grid item xs={12}>
                        <WSDataGrid
                         
                            id="bank-management-list"
                            title="Banks"
                            filterFields={filterRows}
                            columns={columns}
                            source={source}
                            exportCsv={exports}
                            addButton={add ? { label: '', color: 'secondary' } : undefined}
                            onAddButtonClick={handleClick}
                        />
                    </Grid> : <Grid item xs={12}>
                        <WSMobViewDataGrid
                           
                            id="bank-management-list"
                            title="Banks"
                            filterFields={filterRows}
                            columns={columns}
                            source={source}
                            exportCsv={exports}
                            addButton={add ? { label: '', color: 'secondary' } : undefined}
                            onAddButtonClick={handleClick}
                        />
                    </Grid>}
                </Grid> : <PermissionDenied />}
                {selectedId !== null && <ConfirmationPopup
                    apiUrl={'Bank'}
                    id={selectedId}
                    confirmMessage="Are you sure you want to delete this bank?"
                    open={isPopupOpen}
                    onClose={() => setPopupOpen(false)}
                    onConfirm={handleDelete}
                />}
            </>
        );
    }
);




